var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"mt-2 mb-0",attrs:{"no-gutters":""}},[_c('span',{staticStyle:{"font-weight":"700"}},[_vm._v("\n    "+_vm._s(_vm.ruleType.Name)+"\n  ")]),_vm._v("\n   \n  "+_vm._s((" - " + (_vm.$t(
      "components.plan_benefit_rules.rule_type_help_tile.this_rule_uses_the_following_parameters"
    )) + ": " + (_vm.parametersNames()) + ". Usage example: " + (_vm.usageExample())))+"\n  ")])}
var staticRenderFns = []

export { render, staticRenderFns }